import { ChangeEvent, useCallback, useState } from "react";
import { getCustomerList, searchCustomer } from "src/apis/customerApi";


import useUiuxStore from "src/store/useUiuxStore";
import { defaultSAL2020_R01Filter, useSAL2020_R01Store } from "src/containers/mes/SAL/SAL2020_R01/Store_SAL2020_R01";

import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { getEmployeeList } from "src/apis/employeeApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

export const SearchSection_SAL2020_R01 = () => {
	const { SAL2020_R01Filter, setSAL2020_R01Filter } = useSAL2020_R01Store();

    const { codeSearchModalVisible, setCodeSearchModalProps } = useUiuxStore();
    
	const { compCdList, customCdList } = useCommonCodeStore();

    // 달력 팝업 노출 여부 상태
    const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
	
	const custInfoHandleFoucsId = 'infoCustInput_search';

    // 사업장(회사) 선택 핸들러
    const handleFilterCompanyChange = (selectedValue: string) => {
        setSAL2020_R01Filter({ compCd: selectedValue });
    }
	
	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: SAL2020_R01Filter.customCd || '',
				customNm: SAL2020_R01Filter.customNm || '',
			}),
		},		
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: SAL2020_R01Filter,
		setEditData: setSAL2020_R01Filter,
		defaultData: defaultSAL2020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SAL2020_R01_search'
	});

    // UI 렌더링
    return (
		<>
		<SearchSectionForm>
			{/* 사업장(회사) 선택 영역 */}
			<SearchDropDownForm
				label="사업장"
				value={SAL2020_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={handleFilterCompanyChange}
			/>
			<SearchDateRangeForm
				label="매출 조회 기간"
				wrapperOption={{
					wrapperStyle: "w-[300px] min-w-[300px] mr-[10px]",
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[80px] min-w-[80px]',
				}}
				visible={pickerVisible}						
				setVisible={setPickerVisible}
				dateRange={SAL2020_R01Filter.dateRange}		
				setDateRange={(dateRange) => setSAL2020_R01Filter({ dateRange: dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			{/* 거래처 입력 및 검색 영역 */}
			<SearchCodeModalForm
				label="거래처"
				value={SAL2020_R01Filter.customCd}
				valueLabel={SAL2020_R01Filter.customNm}
				handleFoucsId={custInfoHandleFoucsId}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
			/>
		</SearchSectionForm>
		{/* searchedCustomer : {JSON.stringify(searchedCustomer)} */}
		</>
	)
}

export default SearchSection_SAL2020_R01;